export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setReleases(state, releases) {
    state.releases = releases;
  },
  setRelease(state, release) {
    state.release = release;
  }
};
